import React, { useState } from "react";
import { Field, reduxForm, getFormValues } from "redux-form";
import {
  validate,
  normalizePhone,
  stripPhoneFormatting
} from "@components/validation/editProfileForm";
import { trimString } from "@utils";
import { updateCustomerProfile } from "@actions/customerInfo";
import { defaultAction } from "@actions/defaultAction";
import styled from "@emotion/styled";
import RenderFormFieldNew from "@components/forms/RenderFormFieldNew";
import { phone } from "@components/validation";
import SmallButtonSpinner from "@components/SmallButtonSpinner";
import CustomSubmitButton from "./CustomSubmitButton";
import { OPEN_EDIT_PROFILE_MODAL } from "@constants/actionTypes";
import CustomerAddressForm from "./CustomerAddressForm";
import { useDispatch, useSelector } from "react-redux";

const InputWrapper = styled.div`
  position: relative;
  margin-bottom: 18px;
`;

const ButtonWrapper = styled.div`
  margin-top: 20px;
`;

const EditProfileForm = ({ handleSubmit, invalid }) => {
  const dispatch = useDispatch();
  const customerId = useSelector(state => state.customerInfo.id);
  const formData = useSelector(state => getFormValues("profile")(state));

  if (!formData) return null;
  const [submitText, setSubmitText] = useState("Submit");
  const [submitButton, setSubmitButton] = useState("ORANGE_BUTTON");
  const [loading, setLoadSpinner] = useState(false);
  const [errorFromServer, setErrorFromServer] = useState(null);

  const submitProfile = async fields => {
    if (loading) return;
    setLoadSpinner(true);
    fields.id = customerId;
    fields.phone = stripPhoneFormatting(trimString(fields.phone));
    fields.firstname = trimString(fields.firstname);
    fields.lastname = trimString(fields.lastname);
    fields.street = trimString(fields.street);
    fields.city = trimString(fields.city);
    fields.zip = trimString(fields.zip);
    const response = await dispatch(updateCustomerProfile(fields));
    setLoadSpinner(false);
    if (response === "success") {
      setSubmitText("Success");
      setSubmitButton("GREEN_BUTTON");
      setTimeout(() => {
        dispatch(defaultAction(OPEN_EDIT_PROFILE_MODAL, false));
      }, 1000);
    } else if (response?.error) {
      setErrorFromServer(response.error);
    }
  };

  return (
    <form onSubmit={handleSubmit(submitProfile)}>
      <CustomerAddressForm
        errorFromServer={errorFromServer}
        formData={formData}
      />
      <InputWrapper>
        <Field
          name="phone"
          component={RenderFormFieldNew}
          type="text"
          placeholder="Mobile phone number"
          normalize={normalizePhone}
          validate={phone}
        />
      </InputWrapper>
      <ButtonWrapper>
        <CustomSubmitButton
          type="submit"
          styles={{ height: "72px", borderRadius: "36px" }}
          buttonType={submitButton}
          disabled={invalid}
          disabledBackGroundColor={"rgba(119, 121, 132, 0.48)"}
        >
          {loading ? (
            <SmallButtonSpinner img="https://cdn.cardcash.com/website/ui/elements/spinner-white.png" />
          ) : (
            <span>{submitText}</span>
          )}
        </CustomSubmitButton>
      </ButtonWrapper>
    </form>
  );
};

export default reduxForm({
  form: "profile",
  validate,
  enableReinitialize: true
})(EditProfileForm);
